import React from "react";

/* Status Badge */
const StatusBadge = ({ status }) => {
  const isActive = status === "Active";

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 500,
        background: isActive ? "#dcfce7" : "#fee2e2",
        color: isActive ? "#16a34a" : "#dc2626",
      }}
    >
      {status}
    </span>
  );
};

const EmployeeTable = ({ data }) => {   //  RECEIVE DATA HERE
  return (
    <div
      style={{
        marginTop: "20px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        overflow: "hidden",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        
        {/* Header */}
        <thead style={{ background: "#f9fafb" }}>
          <tr>
            {[
              "Emp ID",
              "Name",
              "Email",
              "Department",
              "Phone",
              "Joining Date",
              "Status",
            ].map((head) => (
              <th
                key={head}
                style={{
                  textAlign: "left",
                  padding: "14px 16px",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#374151",
                }}
              >
                {head}
              </th>
            ))}
          </tr>
        </thead>

        {/* Body */}
        <tbody>
          {data.map((emp, index) => (   //  USE data NOT employeeData
            <tr
              key={index}
              style={{
                borderTop: "1px solid #f1f5f9",
              }}
            >
              {/* Emp ID */}
              <td style={{ padding: "14px 16px", fontSize: "13px" }}>
                {emp.id}
              </td>

              {/* Name + Avatar */}
              <td
                style={{
                  padding: "14px 16px",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <img
                  src={emp.avatar}
                  alt="avatar"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600 }}>
                    {emp.name}
                  </div>
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>
                    {emp.role}
                  </div>
                </div>
              </td>

              {/* Email */}
              <td style={{ padding: "14px 16px", fontSize: "13px", color: "#374151" }}>
                {emp.email}
              </td>

              {/* Department */}
              <td style={{ padding: "14px 16px", fontSize: "13px", color: "#374151" }}>
                {emp.department}
              </td>

              {/* Phone */}
              <td style={{ padding: "14px 16px", fontSize: "13px", color: "#374151" }}>
                {emp.phone}
              </td>

              {/* Joining Date */}
              <td style={{ padding: "14px 16px", fontSize: "13px", color: "#374151" }}>
                {emp.joiningDate}
              </td>

              {/* Status */}
              <td style={{ padding: "14px 16px" }}>
                <StatusBadge status={emp.status} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeTable;